import React, { useContext } from 'react';
import { Link } from 'react-router-dom';
import { ApiContext } from '../App';

const Navbar = ({ user, onLogout }) => {
  const { authToken } = useContext(ApiContext);

  return (
    <nav className="navbar">
      <div className="nav-container">
        <Link to="/" className="nav-logo">
          DialectTranslate
        </Link>
        <ul className="nav-menu">
          <li className="nav-item">
            <Link to="/" className="nav-link">Home</Link>
          </li>
          
          {authToken ? (
            <>
              <li className="nav-item">
                <Link to="/dashboard" className="nav-link">Dashboard</Link>
              </li>
              <li className="nav-item">
                <Link to="/translate" className="nav-link">Translate</Link>
              </li>
              <li className="nav-item">
                <Link to="/profile" className="nav-link">Profile</Link>
              </li>
              {/* Show admin link if user is an admin - in a real app, you'd check user role */}
              {user?.email === 'admin@example.com' && (
                <li className="nav-item">
                  <Link to="/admin" className="nav-link">Admin</Link>
                </li>
              )}
              <li className="nav-item">
                <button onClick={onLogout} className="nav-link logout-btn">
                  Logout
                </button>
              </li>
              <li className="nav-item user-greeting">
                Welcome, {user?.name || user?.email}!
              </li>
            </>
          ) : (
            <>
              <li className="nav-item">
                <Link to="/login" className="nav-link">Login</Link>
              </li>
              <li className="nav-item">
                <Link to="/register" className="nav-link signup-btn">Sign Up</Link>
              </li>
            </>
          )}
        </ul>
      </div>
    </nav>
  );
};

export default Navbar;